import { type FC } from "react";
import { Navigate } from "react-router-dom";

import { useFeatureGates } from "../../cof-feature-gates/hooks";
import { CofConfigId } from "../../gql-generated/types";
import { usePageRedirect } from "../../shared/hooks";
import { Feature } from "../../shared/models";

import { TopLevelAlert } from "./TopLevelAlert";
import { LensFoldersList, LensFoldersListV2 } from "./list";

export const LensFoldersPage: FC = () => {
    const redirect = usePageRedirect(Feature.lensFolders);
    const { configs } = useFeatureGates();
    const isMyLensesOrgsV2Enabled = configs[CofConfigId.MyLensesOrgsV2].enabled;

    if (redirect) {
        return <Navigate to={redirect} />;
    }

    return (
        <>
            <TopLevelAlert />
            {isMyLensesOrgsV2Enabled ? <LensFoldersListV2 /> : <LensFoldersList />}
        </>
    );
};
